import React from 'react'
import { Button } from './style'
import PropTypes from 'prop-types'

const CustomButton = props => {
  const { children } = props

  return (
    <Button {...props}>{children}</Button>
  )
}

export default CustomButton

CustomButton.defaultProps = {
  type: 'primary',
  size: 'normal',
  htmlType: 'button'
}

CustomButton.propTypes = {
  type: PropTypes.oneOf(['primary', 'link', 'ghost']),
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  htmlType: PropTypes.string
}